import './component.scss'
import '@splidejs/splide/css';
import Splide from '@splidejs/splide';

document.addEventListener( 'DOMContentLoaded', function() {
  if (document.getElementById('company-images-pc') !== null) {
    const splidePc = new Splide('.splide#company-images-pc', {
      type: 'loop',
    });
    splidePc.mount();
  }

  if (document.getElementById('company-images-sp') !== null) {
    const splideSp = new Splide('.splide#company-images-sp', {
      type: 'loop',
      arrows: false,
    });
    splideSp.mount();
  }
})
